const isInRange = (value, min, max) => {
  return value >= min && value <= max;
};

export { isInRange };
